export default __webpack_public_path__ + "static/media/logo.8fa49659.svg";